/**
 * POS 기기 서비스
 */

import apiClient from './api';
import {
  PosDevice,
  PosDeviceFilter,
  PosDeviceListResponse,
  PosSale,
  PosSaleFilter,
  PosSaleListResponse,
} from '../types/pos';

export const posService = {
  /**
   * POS 기기 목록 조회
   */
  async getDevices(filter: PosDeviceFilter = {}): Promise<PosDeviceListResponse> {
    const params = new URLSearchParams();
    
    if (filter.status) params.append('status', filter.status);
    if (filter.device_type) params.append('device_type', filter.device_type);
    if (filter.search) params.append('search', filter.search);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: PosDeviceListResponse }>(`/admin/pos/devices?${params.toString()}`);
    // return response.data.data;

    return {
      devices: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * POS 기기 상세 조회
   */
  async getDevice(id: number): Promise<PosDevice> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },

  /**
   * POS 기기 등록
   */
  async createDevice(data: Partial<PosDevice>): Promise<PosDevice> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },

  /**
   * POS 기기 수정
   */
  async updateDevice(id: number, data: Partial<PosDevice>): Promise<PosDevice> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },

  /**
   * POS 기기 삭제
   */
  async deleteDevice(id: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },

  /**
   * POS 매출 목록 조회
   */
  async getSales(filter: PosSaleFilter = {}): Promise<PosSaleListResponse> {
    const params = new URLSearchParams();
    
    if (filter.pos_device_id) params.append('pos_device_id', filter.pos_device_id.toString());
    if (filter.start_date) params.append('start_date', filter.start_date);
    if (filter.end_date) params.append('end_date', filter.end_date);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: PosSaleListResponse }>(`/admin/pos/sales?${params.toString()}`);
    // return response.data.data;

    return {
      sales: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * POS 매출 엑셀 업로드
   */
  async uploadSalesExcel(file: File): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    // const formData = new FormData();
    // formData.append('file', file);
    // await apiClient.post('/admin/pos/sales/excel-upload', formData, {
    //   headers: { 'Content-Type': 'multipart/form-data' }
    // });

    throw new Error('Not implemented');
  },
};

